<template>
  <FormMainContainer :title="$t('index.title')">
    <SelectPathQuestion
      :lang="lang"
      :roadside-assistance-url="roadsideAssistanceUrl"
      :service-appointment-url="serviceAppointmentUrl"
      :questions="questions"
    />
  </FormMainContainer>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'
import FormMainContainer from '~concierge/components/FormMainContainer.vue'
import HeaderSection from '~concierge/components/HeaderSection.vue'
import FooterSection from '~concierge/components/FooterSection.vue'
import SelectPathQuestion from '~concierge/components/SelectPathQuestion.vue'
import { SelectPathQuestionData } from '~types/concierge'
import { useSubmissionFormStore } from '~conciergeUiCommons/store/submissionFormStore'

export default defineComponent({
  components: { HeaderSection, FooterSection, SelectPathQuestion, FormMainContainer },
  props: {
    questions: {
      type: Array as PropType<SelectPathQuestionData[]>,
      required: true
    },
    roadsideAssistanceUrl: {
      type: String,
      default: ''
    },
    serviceAppointmentUrl: {
      type: String,
      default: ''
    }
  },
  computed: {
    lang() {
      return useSubmissionFormStore().formLanguage ?? 'fr'
    }
  }
})
</script>
